export type ColumnType = {
  row: [
    {
      component: DashboardSectionKey;
      width?: string;
      padding?: string;
      styles?: any;
    },
  ];
};

export type LayoutType = {
  desktop: {
    leftColumn: ColumnType[];
    middleColumn: ColumnType[];
    rightColumn: ColumnType[];
  };
  mobile: {
    leftColumn: ColumnType[];
    middleColumn: ColumnType[];
    rightColumn: ColumnType[];
  };
};

export type appliedPageLayoutConfigType = {
  breakpoints: {
    desktop: number;
    tablet: number;
    mobile: number;
  };
  layouts: LayoutType;
  globalStyles: {
    containerPadding: string;
    rowGap: string;
    columnGap: string;
  };
};

export type recommendedPageLayoutConfigType = {
  breakpoints: {
    desktop: number;
    tablet: number;
    mobile: number;
  };
  layouts: LayoutType;
  globalStyles: {
    containerPadding: string;
    rowGap: string;
    columnGap: string;
  };
};

export type savedPageLayoutConfigType = {
  breakpoints: {
    desktop: number;
    tablet: number;
    mobile: number;
  };
  layouts: LayoutType;
  globalStyles: {
    containerPadding: string;
    rowGap: string;
    columnGap: string;
  };
};

export const appliedPageLayoutConfig: appliedPageLayoutConfigType = {
  breakpoints: {
    desktop: 1024,
    tablet: 768,
    mobile: 480,
  },
  layouts: {
    desktop: {
      leftColumn: [
        {
          row: [{ component: "APPLIED_FILTERS" }],
        },
      ],
      middleColumn: [
        {
          row: [
            {
              component: "APPLIED_JOB_CARD",
            },
          ],
        },
      ],
      rightColumn: [
        {
          row: [
            {
              component: "BANNER_SECTION",
            },
          ],
        },
      ],
    },
    mobile: {
      leftColumn: [
        {
          row: [{ component: "APPLIED_FILTERS" }],
        },
      ],
      middleColumn: [
        {
          row: [
            {
              component: "APPLIED_JOB_CARD",
            },
          ],
        },
      ],
      rightColumn: [
        {
          row: [
            {
              component: "BANNER_SECTION",
            },
          ],
        },
      ],
    },
  },
  globalStyles: {
    containerPadding: "20px",
    rowGap: "24px",
    columnGap: "20px",
  },
};

export const recommendedPageLayoutConfig: recommendedPageLayoutConfigType = {
  breakpoints: {
    desktop: 1024,
    tablet: 768,
    mobile: 480,
  },
  layouts: {
    desktop: {
      leftColumn: [
        {
          row: [{ component: "RECOMMENDED_FILTERS" }],
        },
      ],
      middleColumn: [
        {
          row: [
            {
              component: "RECOMMENDED_JOB_CARD",
            },
          ],
        },
      ],
      rightColumn: [
        {
          row: [
            {
              component: "BANNER_SECTION",
            },
          ],
        },
      ],
    },
    mobile: {
      leftColumn: [
        {
          row: [{ component: "RECOMMENDED_FILTERS" }],
        },
      ],
      middleColumn: [
        {
          row: [
            {
              component: "RECOMMENDED_JOB_CARD",
            },
          ],
        },
      ],
      rightColumn: [
        {
          row: [
            {
              component: "BANNER_SECTION",
            },
          ],
        },
      ],
    },
  },
  globalStyles: {
    containerPadding: "20px",
    rowGap: "24px",
    columnGap: "20px",
  },
};

export const savedPageLayoutConfig: savedPageLayoutConfigType = {
  breakpoints: {
    desktop: 1024,
    tablet: 768,
    mobile: 480,
  },
  layouts: {
    desktop: {
      leftColumn: [
        {
          row: [{ component: "SAVED_FILTERS" }],
        },
      ],
      middleColumn: [
        {
          row: [
            {
              component: "SAVED_JOB_CARD",
            },
          ],
        },
      ],
      rightColumn: [
        {
          row: [
            {
              component: "BANNER_SECTION",
            },
          ],
        },
      ],
    },
    mobile: {
      leftColumn: [
        {
          row: [{ component: "SAVED_FILTERS" }],
        },
      ],
      middleColumn: [
        {
          row: [
            {
              component: "SAVED_JOB_CARD",
            },
          ],
        },
      ],
      rightColumn: [
        {
          row: [
            {
              component: "BANNER_SECTION",
            },
          ],
        },
      ],
    },
  },
  globalStyles: {
    containerPadding: "20px",
    rowGap: "24px",
    columnGap: "20px",
  },
};
